import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import NoImage from "../../components/NoImage/NoImage";
import PageHeading from "../../components/PageHeading/PageHeading";
import Person1Tab from "../../components/Person1Tab/Person1Tab";
import UserStore from "../../store/UserStore";

const YourTeam = observer(({ selected }) => {
  const [isLoading, setIsLoading] = useState({
    isRMLoading: true,
    isSecondaryRMLoading: true,
  });
  const [connectTeam, setConncetTeam] = useState({
    rmTeam: [],
    secondaryRMTeam: [],
  });

  useEffect(() => {
    if (UserStore.isHydrated) {
      if (!UserStore.connectData?.length) {
        UserStore.getPointOfConnect({
          onFail: (error) => {
            UserStore.setConnectData([]);
            setConncetTeam((prev) => ({ ...prev, rmTeam: [] }));
            setIsLoading((prev) => ({ ...prev, isRMLoading: false }));
          },
          onSuccess: (data) => {
            UserStore.setConnectData(data);
            setConncetTeam((prev) => ({ ...prev, rmTeam: data }));
            setIsLoading((prev) => ({ ...prev, isRMLoading: false }));
          },
        });
      } else {
        setIsLoading((prev) => ({ ...prev, isRMLoading: false }));
        setConncetTeam((prev) => ({ ...prev, rmTeam: UserStore.connectData }));
      }
      if (!UserStore.secondaryRMDetails.data) {
        UserStore.getSecondaryRMDetails({
          onSuccess: (data) => {
            UserStore.setUserStoreData("secondaryRMDetails", {
              isLoading: false,
              error: "",
              data: data[0],
            });
            setConncetTeam((prev) => ({ ...prev, secondaryRMTeam: data }));
            setIsLoading((prev) => ({ ...prev, isSecondaryRMLoading: false }));
          },
          onFail: (error) => {
            UserStore.setUserStoreData("secondaryRMDetails", {
              isLoading: false,
              error,
              data: null,
            });
            setConncetTeam((prev) => ({ ...prev, secondaryRMTeam: [] }));
            setIsLoading((prev) => ({ ...prev, isSecondaryRMLoading: false }));
          },
        });
      } else {
        setIsLoading((prev) => ({ ...prev, isSecondaryRMLoading: false }));
        setConncetTeam((prev) => ({
          ...prev,
          secondaryRMTeam: [UserStore.secondaryRMDetails.data],
        }));
      }
    }
  }, [UserStore.isHydrated]);

  useEffect(() => {
    return () => {
      UserStore.setSelectedContact(undefined);
    };
  }, []);

  useEffect(() => {
    if (UserStore.isHydrated) {
      const data = [
        ...UserStore.connectData,
        ...[UserStore.secondaryRMDetails.data],
      ];

      if (!UserStore.selectedContact && data.length) {
        UserStore.setSelectedContact(data[0]);
      }
    }
  }, [
    UserStore.isHydrated,
    UserStore.connectData?.length,
    UserStore.secondaryRMDetails.data,
  ]);

  const getTeamData = () => {
    const secondaryRMData = connectTeam.secondaryRMTeam?.map((data, index) => ({
      ...data,
      className: `secondary-rm-${index + 1} secondary-rm-full-card-wrapper`,
    }));

    const teamData = [...connectTeam.rmTeam, ...secondaryRMData];

    return teamData.length ? teamData : [];
  };

  return (
    <>
      {!UserStore.isHydrated || Object.values(isLoading).includes(true) ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="your_team_outer_out">
            <div className="your_team_inside">
              <PageHeading
                headingClass="team_head"
                headingText="Meet Your Team"
              />
              <div className="tabs connect_tabs">
                <ul>
                  {getTeamData()?.map((data, index) => {
                    return (
                      <li
                        className={
                          UserStore.selectedContact?.role === data?.role
                            ? "is-active"
                            : ""
                        }
                        onClick={() => UserStore.setSelectedContact(data)}
                      >
                        <a>
                          {UserStore.connectImages[data?.id] ? (
                            <img
                              className="small_tab_image"
                              src={UserStore.connectImages[data?.id]}
                              alt=""
                            />
                          ) : (
                            <NoImage
                              data={data?.name?.split(" ")[0][0]}
                              noImageClass={"no_image_in_tab"}
                            />
                          )}
                          <span className="ml">{data?.name}</span>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div>
                <Person1Tab />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default YourTeam;
